import * as React from "react";
import "./Component4681.css";
const Component4681 = (props: { medium: string, className?: string }) => {
  return (
    <div className={`component-4681 ${props.className || ""}`}>
      {props.medium || "Medium"}
    </div>
  );
};
export default Component4681;
